import { render, staticRenderFns } from "./IconChip.vue?vue&type=template&id=4d562dd5&scoped=true&"
import script from "./IconChip.vue?vue&type=script&lang=js&"
export * from "./IconChip.vue?vue&type=script&lang=js&"
import style0 from "./IconChip.vue?vue&type=style&index=0&id=4d562dd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d562dd5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
